import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import HourglassEnd from './icon-hourglass-end.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HourglassEnd {...validProps} />;
}
SvgComponent.iconName = 'hourglassEnd';

export const HourglassEndIcon = svgIconWrapper(SvgComponent);
